var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CardRow } from "syf-component-library/ui/atoms";
import { Inset, Stack } from "syf-component-library/ui/spacing";
import { Body } from "syf-component-library/ui/typography";
import CardRowText, { InsetResponsive, RowContent, RowHeader, RowTitle, } from "./subcomponents";
var ProfileRow = function (_a) {
    var title = _a.title, _b = _a.titleSpacingSize, titleSpacingSize = _b === void 0 ? "small" : _b, _c = _a.topSpacingSize, topSpacingSize = _c === void 0 ? "small" : _c, children = _a.children, icon = _a.icon, flip = _a.flip;
    return (_jsxs(_Fragment, { children: [title && (_jsxs(_Fragment, { children: [_jsx(Stack, { size: titleSpacingSize }), _jsx(CardRow, __assign({ hasBorderBottom: true }, { children: _jsx(CardRowText, { children: _jsx(Inset, __assign({ left: "base" }, { children: _jsxs(RowHeader, { children: [icon && (_jsx(FontAwesomeIcon, { icon: icon, flip: flip, size: "lg", color: "#525862" })), _jsx(RowTitle, __assign({ "data-cy": "rowTitle" }, { children: title }))] }) })) }) }))] })), _jsx(Stack, { size: topSpacingSize }), _jsx(Body, __assign({ isInline: true }, { children: _jsx(InsetResponsive, { children: _jsx(RowContent, { children: children }) }) }))] }));
};
export default ProfileRow;
